import { computed } from "vue";
import { useThemeContext } from "@/core/composables/useThemeContext";
import FeatureFlags from "@/core/utilities/featureFlags";

const { themeContext } = useThemeContext();

const isResellerQuestionEnabled = computed(() => {
  const modules = themeContext.value?.storeSettings?.modules ?? [];
  return new FeatureFlags(modules).isFeatureEnabled("Thorlabs.Commerce", "EnableResellerQuestion");
});

export function useResellerQuestion() {
  return {
    isResellerQuestionEnabled,
  };
}
